import { FEATURES, TRUST_POINTS } from "./landing-data";

export function LandingFeatures() {
  return (
    <section
      id="funksjoner"
      className="scroll-mt-24 border-t border-slate-200 bg-white py-20 sm:py-28"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-sm font-semibold uppercase tracking-wider text-sky-600">
            Funksjoner
          </p>
          <h2 className="mt-3 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
            Bygget for hele leveransekjeden
          </h2>
          <p className="mt-4 text-lg text-slate-600">
            Fra første kundekontakt til ferdig rapport og faktura — med sporbar
            dokumentasjon underveis.
          </p>
        </div>

        <div className="mt-16 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {FEATURES.map((feature) => (
            <article
              key={feature.title}
              className="group relative rounded-2xl border border-slate-200/80 bg-slate-50/50 p-6 transition hover:border-sky-200 hover:bg-white hover:shadow-lg hover:shadow-sky-500/5"
            >
              <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-sky-500/10 text-sky-600 transition group-hover:bg-sky-500 group-hover:text-white">
                <feature.icon className="h-6 w-6" aria-hidden />
              </div>
              <h3 className="mt-4 text-lg font-semibold text-slate-900">
                {feature.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">
                {feature.description}
              </p>
            </article>
          ))}
        </div>

        <div className="mt-20 grid gap-8 lg:grid-cols-3">
          {TRUST_POINTS.map((point) => (
            <div
              key={point.title}
              className="flex gap-4 rounded-2xl bg-slate-900 p-6 text-white"
            >
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-sky-500/20 text-sky-400">
                <point.icon className="h-5 w-5" aria-hidden />
              </div>
              <div>
                <h3 className="font-semibold">{point.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-400">
                  {point.text}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
